import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import './SubscriptionExpiredOverlay.css';

const SubscriptionExpiredOverlay: React.FC = () => {
    const { isActive, loading, daysRemaining } = useSubscription();
    const { user } = useAuth();
    const navigate = useNavigate();
 
    // If still loading or subscription is active, show nothing
    if (loading || (isActive && (daysRemaining === null || daysRemaining > 0))) {
        return null;
    }
 
    const isAdmin = user?.role === 'osgb_admin' || user?.role === 'admin';
 
    const handleRenew = () => {
        navigate('/subscription');
    };
 
    const handleWhatsApp = () => {
        window.open('https://wa.me/905072136474', '_blank');
    };
 
    return (
        <div className="subscription-expired-overlay">
            <div className="overlay-content">
                <div className="icon-wrapper">
                    <svg viewBox="0 0 24 24" width="64" height="64">
                        <path fill="currentColor" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM11,7h2v6H11Zm0,8h2v2H11Z" />
                    </svg>
                </div>
                <h1>Abonelik Süreniz Dolmuştur</h1>
                <p>
                    {isAdmin 
                      ? 'Kesintisiz hizmet almaya devam edebilmeniz için lütfen aboneliğinizi yenileyiniz.' 
                      : 'Hizmet alınan OSGB\'nin abonelik süresi dolmuştur. Lütfen şirket yetkiliniz ile görüşün.'}
                </p>
                <div className="button-group-overlay">
                    {isAdmin ? (
                        <>
                            <button className="renew-button-overlay" onClick={handleRenew}>
                                <i className="fas fa-credit-card"></i> Paketi Yenile
                            </button>
                            <button className="whatsapp-button-overlay" onClick={handleWhatsApp}>
                                <i className="fab fa-whatsapp"></i> Teknik Destek (WhatsApp)
                            </button>
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionExpiredOverlay;
